import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {planosModuleName} from "../shared/data.service";
import {Plano} from "../shared/plano.model";
import {UtilService} from "../../../shared/services/util.service";
import {editRoute, newRoute, configuracaoModuleName} from "../../../shared/services/data.service";
import {PlanoApiService} from "../shared/plano-api.service";
import {PlanoService} from "../shared/plano.service";
import {PlanoNavigationService} from "../shared/plano-navigation.service";
import {ServicoApiService} from "../../servicos/shared/servico-api.service";
import {manutencoesModuleName} from "../../shared/data.service";
import {ManutencaoService} from "../../shared/manutencao.service";
import {MarcaApiService} from "../../../bens/marcas/shared/marca-api.service";
import {marcasQuery} from "../../../bens/marcas/shared/data.service";
import {CategoriaApiService} from "../../../bens/categorias/shared/categoria-api.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {ServicoPlano} from "../../servicos/shared/servico.model";

@Component({
    template: require('./plano-form.component.html'),
    styles: [require('./plano-form.component.css')]
})
export class PlanosFormComponent implements OnInit {
    planosModule: any = planosModuleName;
    formObject: any = new Plano();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    showServicesMsg: boolean = false;
    module: any = manutencoesModuleName;
    configuracaoModule: any = configuracaoModuleName;
    loadingSpinnerCategorias: boolean = true;

    categoriaObject: any = {};
    categoriaList: any[] = [];
    marcaObject: any = {};
    marcaQuery: any;
    marcaSelectId: string = 'marca';
    servicosList: any[] = [];
    servicoObject: any = {};

    form: FormGroup;
    ativo = new FormControl('');
    titulo = new FormControl('', Validators.required);
    descricao = new FormControl('', Validators.required);
    marca = new FormControl('');
    categoria = new FormControl('');

    constructor(
        private _route: ActivatedRoute,
        private _planosApiService: PlanoApiService,
        private _planosService: PlanoService,
        private _planosNavigationService: PlanoNavigationService,
        private _servicoApiService: ServicoApiService,
        private _utilService: UtilService,
        private _manutencaoService: ManutencaoService,
        private _marcaApiService: MarcaApiService,
        private _categoriaApiService: CategoriaApiService,
        private _autocompleteService: AutoCompleteService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            titulo: this.titulo,
            descricao: this.descricao,
            categoria: this.categoria,
            marca: this.marca
        });
    }

    ngOnInit() {
        this.marcaQuery = this._utilService.cloneObject(marcasQuery);
        this.getCategorias();
        this.testSession();
    }

    clickGoToList() {
        this.goToList();
    }

    clickGoToConfig() {
        this._manutencaoService.goToSetting();
    }

    clickCancel() {
        this.goToList();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object: any = this._utilService.cloneObject(this.formObject),
                list: any = this._utilService.cloneObject(this.servicosList);

            if (list.length) {
                var servicos:Array<ServicoPlano> = [],
                    x: any, lenX: any;
                for (x = 0, lenX = list.length; x < lenX; x++) {
                    if (list[x].servico && list[x].servico.id) {
                        list[x].servicoId = list[x].servico.id;

                        if (list[x].referenciaTempo) {
                            list[x].referenciaTempo = list[x].referenciaTempo.Key;
                        }

                        if (this.formObject.id) {
                            list[x].planoId = this.formObject.id;
                        }

                        delete list[x]['servico'];
                        servicos.push(list[x]);
                    }
                }
                object.Servicos = servicos;
            }

            if (this.marcaObject.id) {
                object.marcaId = this.marcaObject.id;
            } else {
                object.marcaId = null;
            }

            if (this.categoriaObject.id) {
                object.categoriaId = this.categoriaObject.id;
            } else {
                object.categoriaId = null;
            }

            if (!object.Servicos) {
                this.btnSaveDisabled = false;
                this.showServicesMsg = true;
            } else {
                if (this.formObject.id) {
                    this.onEditPlanos(object);
                } else {
                    this.onAddPlanos(object);
                }
            }
        }
    }

    getMarcaObject(object: any) {
        this.marcaObject = object;
        if (object.id) {
            this._utilService.setSelectOnFormControl(this.form, 'marca', object);
        } else {
            this._utilService.setSelectOnFormControl(this.form, 'marca', {id: -1});
        }
    }

    private onAddPlanos(object: Plano) {
        this._planosApiService.onPost(object, this.onDone);
    }

    private onEditPlanos(object: Plano) {
        this._planosApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.goToList();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum plano encontrado com este id.');
                this.clickGoToList();
            }
        }.bind(this));

        this._planosApiService.onGetById(id, onDone);
    }

    private getServicos(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    Response[x].referenciaTempo = this._planosService.getReferenciaTempo(Response[x].referenciaTempo);
                }
                this.servicosList = Response;
            }
        }.bind(this));

        this._servicoApiService.onGetByPlanoServicoPlano(id, onDone);
    }

    private getCategorias() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.categoriaList = Response;
                this.categoriaList.unshift({id: null, categoria: '— Selecione —'});
                this.loadingSpinnerCategorias = false;

                if (this.formObject.categoria) {
                    this.setCategoria(this.formObject.categoria.id);
                } else {
                    this.setCategoria(null);
                }
            }
        }.bind(this));

        this._categoriaApiService.onGetAll(onDone);
    }

    private testSession() {
        var id: number;
        var session: any = this._planosService.getSessionStorage();
        this._planosService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {
        if (this.formObject.marca) {
            this.marcaObject = this._utilService.cloneObject(this.formObject.marca);
            delete this.formObject['marca'];

            let text = this._autocompleteService.getTextSelect2(this.marcaObject, 'marca');
            let selectObject: any = {text: text, id: this.marcaObject.id};

            this._autocompleteService.createOptionOnSelect2(this.marcaSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.marcaSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'marca', this.marcaObject);
        }

        if (this.formObject.categoria) {
            this.categoriaObject = this.formObject.categoria;
            this.setCategoria(this.formObject.categoria.id);
            delete this.formObject['categoria'];
        }

        if (this.formObject.servicoObject) {
            this.servicoObject = this.formObject.servicoObject;
            delete this.formObject['servicoObject'];
        }

        if (this.formObject.servicos) {
            this.servicosList = this.formObject.servicos;
            delete this.formObject['servicos'];
        }
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
        this.getServicos(id);
    }

    private setNewNormal() {
    }

    private goToList() {
        this._planosNavigationService.goToList();
    }

    private setCategoria(categoriaId: number){
        let x: number, lenX: number;

        if (this.categoriaList.length) {
            this.categoriaObject = this.categoriaList[0];
        }

        for (x = 0, lenX = this.categoriaList.length; x < lenX; x++) {
            if (this.categoriaList[x].id === categoriaId) {
                this.categoriaObject = this.categoriaList[x];
                break;
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/plano-form/plano-form.component.ts
 **/